import { Box, Image, Typography } from "@outschool/backpack";
import {
  OUTREACH_CASH_CENTS,
  OUTREACH_REFER_CREDIT_CENTS
} from "@outschool/business-rules";
import {
  renderCurrencyString,
  useLocale,
  useTranslation
} from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import { ExternalLink } from "@outschool/ui-components-shared";
import {
  ModalContext,
  ShareLinkAreaParentProfile,
  uiContextIds
} from "@outschool/ui-components-website";
import React from "react";

import giftImage from "../../../images/invite-page/ReferralsProgram_2023.png";
import * as Env from "../../../shared/Env";

export default function OutReachOrGive20Get20({
  link,
  title,
  supportingCopy,
  modalContext = ModalContext.GenericReferral,
  updateConsent = async () => {}
}: {
  link: string;
  title?: string;
  supportingCopy?: string;
  modalContext?: ModalContext;
  updateConsent?: (value: boolean) => Promise<void>;
}) {
  const { currentUser } = useSession();
  const isEducator =
    !!currentUser?.teacher_approved_at && !currentUser?.suspended_at;

  const FACEBOOK_APP_ID = Env.FACEBOOK_APP_ID;

  const locale = useLocale();

  const recipientCreditInUSD = renderCurrencyString({
    priceInCents: OUTREACH_REFER_CREDIT_CENTS
  });
  const senderCreditInUSD = renderCurrencyString({
    priceInCents: isEducator ? OUTREACH_CASH_CENTS : OUTREACH_REFER_CREDIT_CENTS
  });
  const recipientCreditAmount = renderCurrencyString({
    priceInCents: OUTREACH_REFER_CREDIT_CENTS,
    showCurrencyCode: false
  });

  const { t } = useTranslation(
    "client\\components\\sharing\\OutReachOrGive20Get20"
  );
  const defaultTitle = t(
    "Share {{recipientCreditAmount}} with a friend to try Outschool!",
    {
      recipientCreditAmount
    }
  );
  const defaultSupportingCopy = t(
    "When your friends sign up through your referral link, they get {{recipientCreditInUSD}} to spend on any class and you get {{senderCreditInUSD}} when they take their first class.",
    { recipientCreditInUSD, senderCreditInUSD }
  );

  const termsOfServiceUrl = isEducator
    ? new URL("https://info.outschool.com/outreach-program")
    : new URL("https://support.outschool.com/" + locale + "/articles/2087332");

  return (
    <Box
      flex
      sx={{ alignItems: "center", flexDirection: "column", padding: 20 }}
    >
      <Image src={giftImage} sx={{ height: 80, marginTop: 24 }} />
      <Box sx={{ textAlign: "center", marginY: 8 }}>
        <Typography
          variant={"h5"}
          emphasized
          sx={{
            marginY: "8px"
          }}
        >
          {title ? title : defaultTitle}
        </Typography>
        <Typography
          sx={{
            marginY: "8px"
          }}
        >
          {supportingCopy ? supportingCopy : defaultSupportingCopy}
          <br />
          <ExternalLink url={termsOfServiceUrl.toString()}>
            {t`Terms of use`}
          </ExternalLink>
        </Typography>
      </Box>
      <ShareLinkAreaParentProfile
        updateConsent={updateConsent}
        shareLink={link}
        // @ts-ignore TS(2322): Type '{ shareLink: string; hideInput: boolean; sho... Remove this comment to see the full error message
        hideInput={true}
        copyButtonLabel={t`Copy Link`}
        uiContextId={uiContextIds.SavedClassesPage}
        modalContext={modalContext}
        recipientCredit={recipientCreditInUSD}
        facebookAppId={FACEBOOK_APP_ID}
        sx={{
          width: "100%",
          marginY: 8
        }}
      />
    </Box>
  );
}
